import React from "react";

import { GenericExternalLink } from "@components/generic-external-link";

export function Postscript() {
  return (
    <div className="flex flex-col gap-3">
      <p className="mb-0">
        You will only need to setup your global UTMs once for <b>Postcript</b>.
        Follow the instructions{" "}
        <GenericExternalLink href="https://help.postscript.io/hc/en-us/articles/4403539152539-New-Feature-Adjust-Global-UTM-Parameters#About-Global-UTM-Parameters">
          here
        </GenericExternalLink>{" "}
        to set global UTM parameters.
      </p>
      <div className="flex flex-col gap-2">
        <p className="mb-0">
          Navigate to the <b>Campaign UTM parameters</b> using the instructions
          above.
        </p>
        <p className="mb-0">
          Leave the <b>Source</b> field as <b>Static Value</b> with the value
          set to <code>postscript</code>.
        </p>
        <p className="mb-0">
          Set the <b>Campaign</b> field to <b>Dynamic Value</b> and choose{" "}
          <b>Campaign Name</b> from the dropdown.
        </p>
        <div className="flex flex-col gap-2">
          <p className="mb-0">
            Finally, add a custom parameter with the following structure:
          </p>
          <p className="mb-0">
            <b>Key: </b>
            <code>utm_medium</code>
          </p>
          <p className="mb-0">
            <b>Value:</b> <code>sms</code>
          </p>
        </div>
      </div>
    </div>
  );
}
